import { useEffect, useRef } from 'react';

/**
 * Calls back when the browser shows this page again from its back/forward cache: Back from a payment page restores the
 * page as it was left, state and all, so whatever waited for the page to be left waits for nothing any more.
 */
const usePageRestore = (onRestore) => {
  const latest = useRef(onRestore);
  latest.current = onRestore;

  useEffect(() => {
    const onShow = (event) => {
      if (event.persisted) latest.current();
    };

    window.addEventListener('pageshow', onShow);

    return () => window.removeEventListener('pageshow', onShow);
  }, []);
};

export default usePageRestore;
